import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http';
import { CacheService, ITypeConceptImputationBO } from '@mapfre-tech/amap3';
import { Observable } from 'rxjs';
import { map, tap } from "rxjs/operators";
import * as _ from 'lodash';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class TimeAllocationConceptService {

  className = 'TimeAllocationConceptService';

  constructor(private http: HttpClient, private translateService: TranslateService, private cacheService: CacheService) { }

  getAllConcepts(cache = true, cacheKey = "allImputationConcepts"): Observable<ITypeConceptImputationBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeConceptImputationBO[]>;
    } else {
      const observable = this.http.get<ITypeConceptImputationBO[]>(environment.base_URL + "/types-imputation-concepts").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }

  getActivities(allowCache = true): Observable<ITypeConceptImputationBO[]> {
    return this.getAllConcepts(allowCache).pipe(map((result: any) => {
      return _.filter(result, (item: any) => item.imputablePai);
    }));
  }

  findActivities(params: any) {
    return this.http.get(environment.base_URL_GAIA + "/filtered_imputations", { params });
  }


  getFatherActivities(): Observable<ITypeConceptImputationBO[]> {

    if (this.cacheService.canUseCache("allImputationConceptsFather")) {
      return this.cacheService.getCacheData("allImputationConceptsFather") as object as Observable<ITypeConceptImputationBO[]>;
    }else{
      return this.getAllConcepts(true, "allImputationConceptsFather").pipe(map((result: any) => {
    
        _.remove(result, (item: any) => item.typeConceptImputationFatherId);
        //let filteredData = _.filter(result, item => item.imputablePai);
        _.forEach(result, item => {
          item.imputationsChildren = _.map(item.imputationsChildren, (elem: any) => elem.idTypeConceptImputationPk);
        })
        result = _.filter(result, (item: any) => item.txtTypeConceptImputation.toLowerCase() !== 'trabajos');
        _.forEach(result, (item: any) => {
          this.translateService.stream(item.txtTypeConceptImputation).subscribe(translate => {
            item.txtTypeConceptImputationTranslate = translate;
          });
        });

        return result;
      }));
    }
  }

  getChildrenActivities(): Observable<ITypeConceptImputationBO[]> {

    if (this.cacheService.canUseCache("allImputationConceptsChildren")) {
      return this.cacheService.getCacheData("allImputationConceptsChildren") as object as Observable<ITypeConceptImputationBO[]>;
    }else{
      return this.getAllConcepts(true, "allImputationConceptsChildren").pipe(map((result: any) => {
      
        //const filtered = _.filter(result, item => item.imputablePai);
        const childrens = _.filter(result, (item: any) => item.typeConceptImputationFatherId);
        const data: any = _.reduce(_.map(result, (item: any) => { return { [item.idTypeConceptImputationPk]: item } }), (prev, next) => _.assign(prev, next));
        _.forEach(childrens, (child: any) => {
          this.translateService.stream(data[child.typeConceptImputationFatherId].txtTypeConceptImputation).subscribe(translate1 => {
            this.translateService.stream(child.txtTypeConceptImputation).subscribe(translate2 => {
              child.txtTypeConceptImputationTranslate = `${translate1} / ${translate2}`;
            });
          });
        });
        
        return childrens;
      }));
    }
  }


  newConcept(concept: ITypeConceptImputationBO) {
    return this.http.post(environment.base_URL + "/types-imputation-concepts", concept).pipe(tap(() => this.deleteCache()));
  }

  updateConcept(concept: ITypeConceptImputationBO, id: number) {
    return this.http.put(environment.base_URL + `/types-imputation-concepts/${id}`, concept).pipe(tap(() => this.deleteCache()))
  }

  deleteConcept(id: number) {
    return this.http.delete(environment.base_URL + `/types-imputation-concepts/${id}`).pipe(tap(() => this.deleteCache()))
  }

  deleteCache() {
    // Elimina todas las claves que contienen "allImputationConcepts" (listado, padres e hijos)
    this.cacheService.deleteCache('allImputationConcepts');
  }
}
